import React, { useState, useEffect } from 'react';
import { GitBranch, RefreshCw } from 'lucide-react';

const ChangelogTab = () => {
  const [commits, setCommits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchChangelog = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/changelog?limit=50');
      if (!res.ok) throw new Error(`Request failed (${res.status})`);
      const data = await res.json();
      setCommits(data.commits || []);
      setError(null);
    } catch (e) {
      setError(e.message || 'Failed to load changelog');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchChangelog(); }, []);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
        <h2 style={{ color: '#e2e8f0', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '26px' }}>
          <GitBranch size={26} style={{ color: '#3b82f6' }} />
          Changelog
        </h2>
        <button
          onClick={fetchChangelog}
          style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', background: 'rgba(59,130,246,0.2)', border: '1px solid rgba(59,130,246,0.4)', borderRadius: '8px', color: '#3b82f6', cursor: 'pointer' }}
        >
          <RefreshCw size={16} /> Refresh
        </button>
      </div>

      {error && <div style={{ color: '#ef4444', marginBottom: '16px' }}>Error: {error}</div>}
      {loading ? (
        <p style={{ color: '#94a3b8' }}>Loading...</p>
      ) : commits.length === 0 ? (
        <p style={{ color: '#94a3b8' }}>No commits found.</p>
      ) : (
        <div style={{ background: 'rgba(15,23,42,0.8)', borderRadius: '12px', overflow: 'hidden', border: '1px solid rgba(59,130,246,0.2)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'rgba(59,130,246,0.15)', color: '#94a3b8', textAlign: 'left' }}>
                <th style={{ padding: '12px 16px' }}>Time</th>
                <th style={{ padding: '12px 16px' }}>Commit</th>
                <th style={{ padding: '12px 16px' }}>Author</th>
                <th style={{ padding: '12px 16px' }}>Message</th>
              </tr>
            </thead>
            <tbody>
              {commits.map((c) => (
                <tr key={c.hash} style={{ borderTop: '1px solid rgba(59,130,246,0.1)' }}>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0', whiteSpace: 'nowrap' }}>{new Date(c.date).toLocaleString()}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{
                      padding: '2px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 600,
                      background: 'rgba(59,130,246,0.15)', color: '#3b82f6', fontFamily: 'monospace'
                    }}>
                      {c.shortHash}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0' }}>{c.author}</td>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0' }}>{c.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ChangelogTab;
